import React from 'react';
import { motion } from 'motion/react';
import { Button } from './Button';

const animationVariants = {
  pulse: {
    animate: { 
      scale: [1, 1.05, 1],
    },
    whileHover: { scale: 1.1 },
    whileTap: { scale: 0.95 },
    transition: { 
      scale: { 
        duration: 1.5,
        repeat: Infinity,
        ease: "easeInOut"
      }
    }
  },
  wiggle: {
    animate: { 
      rotate: [0, -2, 2, -1, 1, 0],
    },
    whileHover: { rotate: [0, -3, 3, -2, 2, 0], scale: 1.05 },
    whileTap: { scale: 0.95 },
    transition: { 
      rotate: { 
        duration: 2,
        repeat: Infinity,
        ease: "easeInOut"
      },
      scale: { duration: 0.15 }
    }
  },
  lift: {
    animate: { 
      translateY: [0, -4, 0],
      scale: [1, 1.03, 1],
    },
    whileHover: { translateY: -6, scale: 1.08 },
    whileTap: { scale: 0.95 },
    transition: { 
      translateY: { 
        duration: 2.5,
        repeat: Infinity,
        ease: "easeInOut"
      },
      scale: { 
        duration: 2.5,
        repeat: Infinity,
        ease: "easeInOut"
      }
    }
  },
  breathe: {
    animate: { 
      scale: [1, 1.1, 1],
    },
    whileHover: { scale: 1.15 },
    whileTap: { scale: 0.95 },
    transition: { 
      scale: { 
        duration: 2,
        repeat: Infinity,
        ease: "easeInOut"
      }
    }
  },
  none: {
    whileHover: {},
    whileTap: {},
    transition: {}
  }
};

const AnimatedButtonComponent = ({
  animation = 'pulse',
  text = 'Animated Button',
  size = 'xl',
  align = 'center',
  url = '',
  variant = 'primary',
  target = '_self',
  icon = 'none',
  ...rest
}) => {
  const motionProps = animationVariants[animation] || animationVariants.pulse;

  return (
    <motion.div
      animate={motionProps.animate}
      whileHover={motionProps.whileHover}
      whileTap={motionProps.whileTap}
      transition={motionProps.transition}
      className="flex justify-center"
    >
      {Button.render({
        text,
        size,
        align,
        url,
        variant,
        target,
        icon,
        ...rest
      })}
    </motion.div>
  );
};

export const AnimatedButton = {
  fields: {
    text: Button.fields.text,
    url: {
      type: 'text',
      label: 'Link (URL)',
      placeholder: 'Wird automatisch auf Quiz-URL gesetzt'
    },
    variant: Button.fields.variant,
    size: Button.fields.size,
    target: Button.fields.target,
    icon: Button.fields.icon,
    animation: {
      type: 'select',
      label: 'Animation',
      options: [
        { label: 'Atmen (Loop)', value: 'breathe' },
        { label: 'Pulsieren', value: 'pulse' },
        { label: 'Wackeln', value: 'wiggle' },
        { label: 'Anheben', value: 'lift' },
        { label: 'Keine', value: 'none' }
      ]
    }
  },
  defaultProps: {
    text: 'Jetzt bewerben',
    url: '/apply/campaign-id', // Show placeholder URL in editor
    variant: 'primary',
    size: 'xl',
    target: '_self',
    icon: 'none',
    animation: 'breathe'
  },
  render: AnimatedButtonComponent
};
